var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.641,
    height: 17,
    viewBox: "0 0 15.641 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.133,
    y1: 0.279,
    x2: 1.133,
    y2: 0.721,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(-95 -4062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(95 4062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invoice",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M16.9,0h-.434a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,13.861,0H12.124a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,9.517,0H7.779a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,5.172,0H4.738A1.6,1.6,0,0,0,3,1.417V15.583A1.6,1.6,0,0,0,4.738,17h.434a1.2,1.2,0,0,1,1.3-1.062A1.2,1.2,0,0,1,7.779,17H9.517a1.2,1.2,0,0,1,1.3-1.062A1.2,1.2,0,0,1,12.124,17h1.738a1.2,1.2,0,0,1,1.3-1.062A1.2,1.2,0,0,1,16.468,17H16.9a1.6,1.6,0,0,0,1.738-1.417V1.417A1.6,1.6,0,0,0,16.9,0Z",
    transform: "translate(-3 0)",
    fill: "#e6e6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M16.9,0h-.434a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,13.861,0H12.124a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,9.517,0H7.779a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,5.172,0H4.738A1.6,1.6,0,0,0,3,1.417v.177A1.6,1.6,0,0,1,4.738.177h.434a1.2,1.2,0,0,0,1.3,1.062A1.2,1.2,0,0,0,7.779.177H9.517a1.2,1.2,0,0,0,1.3,1.062,1.2,1.2,0,0,0,1.3-1.062h1.738a1.2,1.2,0,0,0,1.3,1.062,1.2,1.2,0,0,0,1.3-1.062H16.9a1.6,1.6,0,0,1,1.738,1.417V1.417A1.6,1.6,0,0,0,16.9,0Z",
    transform: "translate(-3 0)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M4.738,23.344h.434a1.2,1.2,0,0,1,1.3-1.062,1.2,1.2,0,0,1,1.3,1.063H9.517a1.2,1.2,0,0,1,1.3-1.062,1.2,1.2,0,0,1,1.3,1.063h1.738a1.2,1.2,0,0,1,1.3-1.062,1.2,1.2,0,0,1,1.3,1.063H16.9a1.6,1.6,0,0,0,1.738-1.417V21.75A1.6,1.6,0,0,1,16.9,23.167h-.434a1.2,1.2,0,0,0-1.3-1.062,1.2,1.2,0,0,0-1.3,1.062H12.124a1.2,1.2,0,0,0-1.3-1.062,1.2,1.2,0,0,0-1.3,1.062H7.779a1.2,1.2,0,0,0-1.3-1.062,1.2,1.2,0,0,0-1.3,1.062H4.738A1.6,1.6,0,0,1,3,21.75v.177A1.6,1.6,0,0,0,4.738,23.344Z",
    transform: "translate(-3 -6.344)",
    fill: "#010101",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M6,7.125H17.391v.708H6ZM6,5H17.391v.708H6Zm0,6.375h6.644v.708H6ZM6,9.25H17.391v.708H6ZM6,13.5h6.644v.708H6Zm10.441-2.479h-.949v.419a1.136,1.136,0,0,0-.949,1c0,.586.639,1.062,1.424,1.062.262,0,.475.159.475.354s-.212.354-.475.354H14.543v.708h.949v.354h.949v-.419a1.136,1.136,0,0,0,.949-1c0-.586-.639-1.062-1.424-1.062-.262,0-.475-.159-.475-.354s.212-.354.475-.354h1.424v-.708h-.949Z",
    transform: "translate(-3.875 -1.458)",
    fill: "#2d98d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M16.9,0h-.434a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,13.861,0H12.124a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,9.517,0H7.779a1.2,1.2,0,0,1-1.3,1.062A1.2,1.2,0,0,1,5.172,0H4.738A1.6,1.6,0,0,0,3,1.417V15.583A1.6,1.6,0,0,0,4.738,17h.434a1.2,1.2,0,0,1,1.3-1.062A1.2,1.2,0,0,1,7.779,17H9.517a1.2,1.2,0,0,1,1.3-1.062A1.2,1.2,0,0,1,12.124,17h1.738a1.2,1.2,0,0,1,1.3-1.062A1.2,1.2,0,0,1,16.468,17H16.9a1.6,1.6,0,0,0,1.738-1.417V1.417A1.6,1.6,0,0,0,16.9,0Z",
    transform: "translate(-3 0)",
    fill: "url(#linear-gradient)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.ba82ec54c9d412f6a91989224cc6e2b2.svg";
export { ForwardRef as ReactComponent };